;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import type { SvgIconProps } from "@mui/material/SvgIcon"
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined"
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined"
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined"
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined"
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined"
import SendOutlinedIcon from "@mui/icons-material/SendOutlined"
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined"
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined"
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined"
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined"
import type { AdminNavIcon as AdminNavIconName } from "../../../lib/admin/adminNav"

const ICONS: Record<AdminNavIconName, React.ComponentType<SvgIconProps>> = {
  dashboard: SpaceDashboardOutlinedIcon,
  users: PeopleAltOutlinedIcon,
  groups: GroupsOutlinedIcon,
  orgs: ApartmentOutlinedIcon,
  articles: ArticleOutlinedIcon,
  newsletter: SendOutlinedIcon,
  campaigns: CampaignOutlinedIcon,
  email: MarkEmailReadOutlinedIcon,
  home: HomeOutlinedIcon,
  aiUsage: AutoAwesomeOutlinedIcon,
}

// Icon glyph shared by the admin dropdown rows and the dashboard tool tiles.
function AdminNavIcon({
  name,
  ...props
}: { name: AdminNavIconName } & SvgIconProps) {
  const Icon = ICONS[name]
  return <Icon aria-hidden="true" {...props} />
}

export default AdminNavIcon
